import type { App, Directive, DirectiveBinding } from 'vue'
import { useI18n } from '@/hooks/web/useI18n'
import _ from 'lodash';
// import router from '@/router'
import { usePermissionStore, usePermissionStoreWithOut} from '@/store/modules/permission'
import { useUserStoreWithOut } from '@/store/modules/user'

const { t } = useI18n()

const hasPermission = (value: string): boolean => {
  // const permission = (router.currentRoute.value.meta.permission || []) as string[]
  const userPermissionStore = usePermissionStoreWithOut()
  const userStore = useUserStoreWithOut()

  const roles = userStore.getUserInfo?.userRoles?.map(it => { return { name: it.name,  code:it.code }; })
  // 这里保存后端返回的function_code
  const options = userPermissionStore.getPermissions?.map(it => { return { name: it.name,  code:it.code }; })
  const permissions = [...options, ...roles]
  if (!value) {
    throw new Error(t('permission.hasPermission'))
  }
  if(~value.indexOf('&&')) {
    const arr = value.split("&&")
     // it -> 配置的表达式
    return arr.every(it => permissions?.some(it2 => _match(it, it2.code)))
  }
  if(~value.indexOf('||')) {
    const arr2 = value.split("||")
    // it -> 配置的表达式
    return arr2.some(it => permissions?.some(it2 => _match(it, it2.code)))
  }
  return permissions?.some(it => it.code == value)
}

const _match = (permiExpress: string, selfPermi: string) => {
  if(permiExpress == selfPermi) {
     return true
  }
  if(_.startsWith(permiExpress, 'role::')) {
    const rolePrmiExpress = _.split(permiExpress, '::')[1]
    return _match(rolePrmiExpress, selfPermi)
  }
  return false
}

function hasPermi(el: Element, binding: DirectiveBinding) {
  const value = binding.value

  const flag = hasPermission(value)
  if (!flag) {
    el.parentNode?.removeChild(el)
  }
}
const mounted = (el: Element, binding: DirectiveBinding<any>) => {
  hasPermi(el, binding)
}

const permiDirective: Directive = {
  mounted
}

export const setupPermissionDirective = (app: App<Element>) => {
  app.directive('hasPermi', permiDirective)
}

export default permiDirective
